import MuiIconButton from "@material-ui/core/IconButton";
import styled from "styled-components/macro";

export default styled(MuiIconButton)`
  height: 48px;
  width: 48px;
`;
